import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * ConfirmDialog — shared MUI-based replacement for window.confirm.
 *
 * Props:
 *   open       boolean
 *   onClose    () => void          — called when dialog is dismissed (cancel/X/backdrop)
 *   onConfirm  () => void          — called when the user confirms
 *   title      string              — dialog title (default: "Confirm")
 *   message    string | ReactNode  — body text / content
 *   confirmLabel  string           — confirm button label (default: "Confirm")
 *   cancelLabel   string           — cancel button label (default: "Cancel")
 *   destructive   boolean          — renders the confirm button in the error color
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        {title}
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {typeof message === 'string'
          ? <Typography variant="body2">{message}</Typography>
          : message}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button variant="outlined" onClick={onClose}>{cancelLabel}</Button>
        <Button
          variant="contained"
          color={destructive ? 'error' : 'primary'}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}